export const loadApplets = async (url:string, containerClass:string, loadingMore:boolean = false) => {
  const appletContainer = document.querySelector(`section[data-tab] ${containerClass}`)

  if (!appletContainer) return

  if (loadingMore) {
    appletContainer.parentElement?.classList.add("loading")
  }

  await fetch(url)
    .then(response => response.text())
    .then(html => {
      if (loadingMore) {
        appletContainer.parentElement?.classList.remove("loading")
        appletContainer.insertAdjacentHTML("beforeend", html)
      } else {
        appletContainer.classList.remove("loading")
        appletContainer.insertAdjacentHTML("afterbegin", html)
      }
    })
}

export const loadMoreApplets = async (discoverAppletsContainer:Element | null, discoverMoreAppletsUrl:string) => {
  const loadMoreButton = discoverAppletsContainer?.querySelector("#load-more-applets")
  if (!loadMoreButton) return

  loadMoreButton.addEventListener("click", async () => {
    loadMoreButton.parentElement?.remove()
    await loadApplets(discoverMoreAppletsUrl, ".discover_applets .web-applet-cards", true)
  })
}
